import { render, staticRenderFns } from "./AggrergationPairsDialog.vue?vue&type=template&id=2ecdd7ac&scoped=true&"
import script from "./AggrergationPairsDialog.vue?vue&type=script&lang=js&"
export * from "./AggrergationPairsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AggrergationPairsDialog.vue?vue&type=style&index=0&id=2ecdd7ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecdd7ac",
  null
  
)

export default component.exports